<template>
  <div>
    <el-table :data="items" size="small" class="mt-10">
      <el-table-column align="left" label="名称" prop="name">
        <template slot-scope="scope">
          {{ scope.row.name }}
          <div v-if="scope.row.asset_type == 2">
            <el-tag size="mini">固定资产</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        :label="`成品属性 ${codeType == 1 ? '/ 固定配件' : ''}`"
        prop="code"
        min-width="300"
      >
        <template slot-scope="scope">
          <div class="font-14" style="display: flex">
            <div style="min-width: 45px">属性：</div>
            <el-breadcrumb separator="|">
              <el-breadcrumb-item>{{
                codeType == 1 ? '编号' : '编码'
              }}</el-breadcrumb-item>
              <el-breadcrumb-item
                v-for="(item, index) in scope.row.custom_params"
                :key="item.label + index"
                >{{ item.label }}
                <el-tag size="mini" v-if="item.model_alias">规</el-tag>
              </el-breadcrumb-item>
              <el-breadcrumb-item>状态</el-breadcrumb-item>
              <el-breadcrumb-item>备注</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="font-14" style="display: flex" v-if="codeType == 1">
            <div style="min-width: 45px">配件：</div>
            <el-breadcrumb separator="|">
              <el-breadcrumb-item
                v-for="item in scope.row.item_template_names"
                :key="item"
                >{{ item }}</el-breadcrumb-item
              >
            </el-breadcrumb>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="下属分组"
        prop="children_groups"
        v-if="codeType == 1"
      >
        <template slot-scope="scope">
          <template v-if="scope.row.children_groups">
            <div v-for="g in scope.row.children_groups.split('、')" :key="g">
              {{ g }}
            </div>
          </template>
          <template v-else>无</template>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-popconfirm
            v-if="scope.row.item_count == 0"
            title="确认删除该成品分类吗？"
            @confirm="hanldeDelte(scope.row, scope.$index)"
          >
            <el-link
              slot="reference"
              v-permission="
                category == 1
                  ? Auth.productTemplateDelete
                  : Auth.instrumentTemplateDelete
              "
              type="danger"
              class="font-12 ml-5"
              :underline="false"
              >删除</el-link
            >
          </el-popconfirm>

          <el-link
            class="font-12 ml-5"
            :underline="false"
            type="primary"
            v-permission="
              category == 1
                ? Auth.productTemplateEdit
                : Auth.instrumentTemplateEdit
            "
            @click.native="editItem(scope.row, scope.$index)"
            >编辑</el-link
          >
          <el-link
            class="font-12 ml-5"
            :underline="false"
            v-permission="
              category == 1
                ? Auth.productTemplateDetail
                : Auth.instrumentTemplateDetail
            "
            type="primary"
            @click="$router.push(`${$route.path}/${scope.row.id}`)"
            >详情</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <item-former
      :model="model"
      :show.sync="formerVisible"
      @updated="updatedCallback"
    ></item-former>
  </div>
</template>

<script>
import { productTemplateDelete } from '@/service/getData'
import ItemFormer from './former'

export default {
  components: {
    ItemFormer,
  },
  props: {
    items: null,
    category: {
      type: Number,
      default: 0,
    },
    codeType: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      model: {},
      formerVisible: false,
      detailVisible: false,
      editIndex: 0,
    }
  },
  methods: {
    editItem(item, index) {
      let cloneItem = this.clone(item)
      cloneItem.custom_params.map((item) => {
        if (!item.type) {
          item.type = 1
          item.options = ''
        }
      })

      this.model = cloneItem
      this.editIndex = index
      this.formerVisible = true
    },
    updatedCallback(data) {
      if (
        data.template_group_id != this.items[this.editIndex].template_group_id
      ) {
        this.items.splice(this.editIndex, 1)
        return
      }
      this.$set(this.items, this.editIndex, data)
    },
    async hanldeDelte(item, index) {
      let res = await productTemplateDelete(item.id)
      if (res.code == 0) {
        this.items.splice(index, 1)
      }
    },
  },
}
</script>

<style>
.product-params .el-breadcrumb__inner {
  color: red !important;
}
</style>